import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Styles from './Link.styles';

const LinkStyled = styled(Link)`${Styles.link}`; // prettier-ignore

/**
 * Link component
 * @param {*} props - component props
 * @returns {jsx}
 */
const LinkComponent = (props) => {
  const {
    preloadDisabled, children, href, lastItem, isMobile, isActive, ...otherProps
  } = props;

  if (preloadDisabled) {
    return <a href={href} {...otherProps}>{children}</a>;
  }

  return (
    <LinkStyled to={href} {...otherProps}>
      {children}
    </LinkStyled>
  );
};

LinkComponent.propTypes = {
  preloadDisabled: PropTypes.bool
};

export default LinkComponent;
